// libs
import React, { useState } from 'react';

// components
import Modal from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/components/CollapsibleContent/components/AttributeWidget/components/Modal';

// styles
import { Container, InfoTitle, InfoContent, Info } from './styles';

// constants
const SOLD_BY = 'Sold By';
const NYKAA_FASHION = 'Nykaa Fashion';
export const EVENTS = {
  TRACK_SOLD_BY_CLICKED: 'sold-by-nykaa-fashion-clicked',
};

// types
import { IWidget } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/types';

//helpers
import sanitizeHTML from 'shared/helpers/utils/sanitizeHTML';
import { isNFApp } from 'shared/helpers/globals/domainHelpers';

interface IAttributeWidget {
  widget: IWidget;
  className?: string;
}

function AttributeWidget({ widget, className }: IAttributeWidget) {
  const [modalOpen, setModalOpen] = useState(false);
  const handleOnClick = () => {
    setModalOpen(true);
  };

  const wrapComponent = (value: string, title: string) => {
    if (title === SOLD_BY && value && value.includes(NYKAA_FASHION) && isNFApp()) {
      return (
        <button className="underline-btn" onClick={handleOnClick}>
          <InfoContent
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(value) }}
            data-test="info-value"
          />
        </button>
      );
    }
    return (
      <InfoContent
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(value) }}
        data-test="info-value"
      />
    );
  };

  return (
    <Container className={className}>
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} />

      {widget.attributes &&
        widget.attributes.map((item, id) => (
          <Info key={`attribute-widget-${item.label || id}`}>
            <InfoTitle className="prod-info-header" data-test="info-item-title">
              {item.label}
            </InfoTitle>
            {wrapComponent(item.value, item.label)}
          </Info>
        ))}
    </Container>
  );
}

export default AttributeWidget;
